import AsideBox from 'Components/common/AsideBox';
import React from 'react';
import classnames from 'classnames';
import { component } from './styles.module.scss';
// import { getEligibleCountries } from '../PriorityGroups';

const Intro = (props) => {
  // const {
  //   vaccinationSummaryStatistics,
  //   priorityGroupsSummaryStatistics,
  // } = props;

  // const countries = getEligibleCountries(vaccinationSummaryStatistics, priorityGroupsSummaryStatistics);

  return (
    <section className={classnames(component)}>
      <h3>Who is getting vaccinated?</h3>

      <p>Because of the limited availability of vaccines, most countries are prioritizing certain groups of people to receive their shots before others. People who are older or more likely to become very ill or die from COVID-19 are usually prioritized over those who are young and healthy. Some groups are prioritized because they are more likely to come into contact with an infected person based on what they do or where they live and, in turn, infect others.</p>
      
      <p>Reuters has collected information on these priority groups for dozens of countries and determined which groups are currently eligible for vaccination.</p>

      <p>Tap through the table below to see detailed information for each country. We will update this page as more countries acquire vaccines and announce their rollout plans.</p>

      <AsideBox
        title='You need to know'
        red
        source={`Reuters will strive to keep this data updated, but it may lag behind the current situation in your country. Consult your local health department for the most up-to-date information on whether you are eligible to receive a vaccine. (You can often find a link in the table below.)
    
For comparison purposes, Reuters has standardized the names of rollout phases and priority groups. For groups given access based on complex conditions, such as where people work or a pre-existing medical condition, a more detailed description of that group is also included in the table.`}
      />
    </section>
  );
};

export default Intro;
